import {Container, TextDescription} from './styled'
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import {BackupStatus} from "@dropDesk/domain/entities/ticket/backup/backup_data";

export default function TagBackup(
    {
        label,
        status,
        width
    }: {
        label: string,
        status: BackupStatus,
        width?: number
    }
) {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    const getBackgroundColorTagBackup = (status: BackupStatus): string => {

        if (status === BackupStatus.scheduled) {
            return SharedColors.onOpenStatus;
        }
        if (status === BackupStatus.stoppedWithError) {
            return SharedColors.onCancelStatus;
        }
        if (status === BackupStatus.inProgress) {
            return SharedColors.onAttendingStatus;
        }
        return SharedColors.onCloseStatus;
    }


    const getColorTagBackup = (status: BackupStatus): string => {

        if (status === BackupStatus.scheduled) {
            return SharedColors.textOpenStatus;
        }
        if (status === BackupStatus.inProgress) {
            return SharedColors.textAttendingStatus;
        }
        if (status === BackupStatus.stoppedWithError) {
            return SharedColors.textCancelStatus;
        }
        return SharedColors.textCloseStatus;
    }

    return (
        <Container background={getBackgroundColorTagBackup(status)} border={'transparent'} width={width}>
            <TextDescription color={getColorTagBackup(status)}>{label}</TextDescription>
        </Container>
    )
}
